import { alpha, Theme } from "@mui/material";

export const cardStyles = (theme: Theme) => ({
  elevation: 0,
  sx: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    borderRadius: 3,
    border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
    boxShadow: `0 4px 20px ${alpha(theme.palette.common.black, 0.06)}`,
    overflow: "hidden",
  },
});

export const cardContentStyles = {
  sx: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    width: "100%",
    p: 3,
  },
};

export const sectionHeaderStyles = (theme: Theme) => ({
  variant: "h6" as const,
  sx: {
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    fontWeight: 600,
    color: theme.palette.text.primary,
    lineHeight: 1.2,
  },
});
